import Rubigram from './Rubigram';

export default Rubigram;